import React from 'react'
import { Typography } from '@material-ui/core'
import { CampaignType } from '../../../../constants/marketingCampaign'
import { CampaignDefinition } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FreeDeliveryRuleState } from './types'
import { validateFreeDeliveryRule } from './validate'
import { buildFreeDeliveryFormValues } from './buildFormValues'
import { FreeDeliveryRuleStep } from './RuleStep.view'
import { FreeDeliveryConfirmationSummary } from './ConfirmationSummary.view'

const ruleDescription = (
	<>
		<Typography variant="body2" style={{ color: '#616161', marginBottom: 14, lineHeight: 1.65 }}>
			Définissez un <strong style={{ color: '#212121' }}>montant minimum de panier</strong> à partir
			duquel les <strong style={{ color: '#212121' }}>frais de livraison sont offerts</strong>. Cette
			campagne ne s&apos;applique qu&apos;aux commandes en <strong style={{ color: '#212121' }}>livraison</strong>.
		</Typography>
	</>
)

function getInitialRuleFromCampaign(campaign: any): FreeDeliveryRuleState {
	return {
		threshold: campaign.config?.threshold ?? null,
	}
}

export const freeDeliveryDefinition: CampaignDefinition<FreeDeliveryRuleState> = {
	type: CampaignType.FREE_DELIVERY_AFTER_THRESHOLD,
	RuleStep: FreeDeliveryRuleStep,
	ConfirmationSummary: FreeDeliveryConfirmationSummary,
	defaultRule: { threshold: null },
	validateRule: validateFreeDeliveryRule,
	buildFormValues: buildFreeDeliveryFormValues,
	ruleDescription,
	getInitialRuleFromCampaign,
	confirmationLimitPolicy: 'none',
	showOrderTypesInConfirmation: false,
	forceDeliveryOrderType: true,
	allowsPermanent: true,
}
